import React from "react";
import "./Services.css";
import Icons from "./Icons";

const Services = () => {
  return (
    <div className="services">
      <h3>Services</h3>
      <h1>What we offer</h1>
      <Icons />
    </div>
  );
};

export default Services;
